<div class="container-fluid from-top-pad" [ngClass]="{'service-bg': !dialogRef}">
    <!-- Titles -->
    <div class="row" *ngIf="!dialogRef">
        <div class="col-md-12">
            <h1>
                <a href="#/account">{{'gen_my_account' | translate}}</a> / {{'gen_subscriber_info' | translate}}
            </h1>
            <hr>
        </div>
    </div>

    <!-- Email Form -->
    <div class="row">
        <div class="col-md-12">
            <h3 class="text-center" *ngIf="dialogRef">{{'gen_subscriber_info' | translate}}</h3>
            <p class="text-center" *ngIf="!dialogRef"> {{'gen_subscriber_info_edit' | translate}} </p>
            <p class="text-center" *ngIf="dialogRef"> {{'gen_subscriber_info_about' | translate}}</p>
        </div>

        <!-- Form -->
        <div class="form-group mx-auto col-md-6 mt-0" [formGroup]="subscriberGroup">
            <!-- First Name -->
            <mat-form-field class="form-element w-50 pr-2" appearance="fill">
                <mat-label>{{'gen_first_name' | translate}}</mat-label>
                <textarea class="in-text-areas" matInput placeholder="{{'gen_first_name' | translate}}"
                    formControlName="firstName">
                    </textarea>

                <!-- Errors -->
                <mat-error *ngIf="subscriberGroup.controls.firstName.errors?.required">
                    {{'error_required_error' | translate}}
                </mat-error>
                <mat-error *ngIf="subscriberGroup.controls.firstName.errors?.pattern">
                    {{'error_regex_chars_only' | translate}}
                </mat-error>
            </mat-form-field>

            <!-- Last Name -->
            <mat-form-field class="form-element w-50 pl-2" appearance="fill">
                <mat-label>{{'gen_last_name' | translate}}</mat-label>
                <textarea class="in-text-areas" matInput placeholder="{{'gen_last_name' | translate}}"
                    formControlName="lastName">
                    </textarea>

                <!-- Errors -->
                <mat-error *ngIf="subscriberGroup.controls.lastName.errors?.required">
                    {{'error_required_error' | translate}}
                </mat-error>
                <mat-error *ngIf="subscriberGroup.controls.lastName.errors?.pattern">
                    {{'error_regex_chars_only' | translate}}
                </mat-error>
            </mat-form-field>

            <!-- Address -->
            <mat-form-field class="form-element w-75 pr-2" appearance="fill">
                <mat-label>{{'gen_address' | translate}}</mat-label>
                <textarea class="in-text-areas" matInput placeholder="{{'gen_address' | translate}}"
                    formControlName="address"></textarea>

                <!-- Errors -->
                <mat-error *ngIf="subscriberGroup.controls.address.errors?.required">
                    {{'error_required_error' | translate}}
                </mat-error>
                <mat-error *ngIf="subscriberGroup.controls.address.errors?.pattern">
                    {{'error_regex_num_chars' | translate}}
                </mat-error>
            </mat-form-field>

            <!-- Address Number -->
            <mat-form-field class="form-element w-25 pl-2" appearance="fill">
                <mat-label>{{'gen_address_number' | translate}}</mat-label>
                <textarea class="in-text-areas" matInput placeholder="{{'gen_address_number' | translate}}"
                    formControlName="addressNum"></textarea>

                <!-- Errors -->
                <mat-error *ngIf="subscriberGroup.controls.addressNum.errors?.required">
                    {{'error_required_error' | translate}}
                </mat-error>
                <mat-error *ngIf="subscriberGroup.controls.addressNum.errors?.pattern">
                    {{'error_regex_numbers_only' | translate}}
                    {{'error_regex_length' | translate}} 3
                </mat-error>
            </mat-form-field>

            <!-- City -->
            <mat-form-field class="form-element w-75 pr-2" appearance="fill">
                <mat-label>{{'gen_city' | translate}}</mat-label>
                <textarea class="in-text-areas" matInput placeholder="{{'gen_city' | translate}}"
                    formControlName="city">
                </textarea>
                <!-- Errors -->
                <mat-error *ngIf="subscriberGroup.controls.city.errors?.required">
                    {{'error_required_error' | translate}}
                </mat-error>
                <mat-error *ngIf="subscriberGroup.controls.city.errors?.pattern">
                    {{'error_regex_chars_only' | translate}}
                </mat-error>
            </mat-form-field>

            <!-- Postal Code -->
            <mat-form-field class="form-element w-25 pl-2" appearance="fill">
                <mat-label>{{'gen_postal_code' | translate}}</mat-label>
                <textarea class="in-text-areas" matInput placeholder="{{'gen_postal_code' | translate}}"
                    formControlName="postalCode">
                </textarea>
                <!-- Errors -->
                <mat-error *ngIf="subscriberGroup.controls.postalCode.errors?.required">
                    {{'error_required_error' | translate}}
                </mat-error>
                <mat-error *ngIf="subscriberGroup.controls.postalCode.errors?.pattern">
                    {{'error_regex_numbers_only' | translate}}
                    {{'error_regex_length' | translate}} 5
                </mat-error>
            </mat-form-field>

            <!-- Action Button -->
            <button class="button w-100" (click)="save()" [disabled]="subscriberGroup.status == 'INVALID'">
                {{'gen_save' | translate}}
            </button>
        </div>
    </div>
</div>